const prodItemBundle = document.querySelector('.products__list--item.is-bundle');
const prodBundleInfo = prodItemBundle?.querySelector('.product__info');
const bundleRadioSvg = prodItemBundle?.querySelector('svg');
const originalItem = document.querySelector('.products__list--item.original-product');
const bullets = originalItem?.querySelector('.bullet-list__wrapper');
const sellingPlans = originalItem?.querySelector('.product-sellings-plans')
const freeOrderText = originalItem?.querySelector('.free-order-text')
let rechargeWidget = null;

function getRecharge() {
  setTimeout(function () {
    rechargeWidget = document.querySelector('.rc-container-wrapper');
    if (rechargeWidget) {
      rechargeWidget?.remove();
      selectedItem.append(rechargeWidget);
    } else {
      getRecharge();
    }
  }, 6000);
}

(function(){
  // Bail out entirely if this page doesn't have the bundle product markup
  const productsList = document.querySelector('.products__list');
  if (!productsList || !prodItemBundle || !originalItem) return;

  let selectedItemVariants = document.querySelector('.is-single .product__form__holder')

  productsList.addEventListener('click', (e) => {
    const clickedItem = e.target.closest('.products__list--item');
    if (!clickedItem || clickedItem.classList.contains('is-selected')) return;

    let isBundle = e.target.classList.contains('is-bundle');
    const listItem = clickedItem;

    const items = document.querySelectorAll('.products__list--item');
    items.forEach((item) => {
      item.classList.remove('is-selected');
    });

    listItem.append(selectedItemVariants);
    listItem.append(sellingPlans);
    listItem.append(freeOrderText);

    if (isBundle) {
      changeImage(1);
    } else {
      changeImage(0);
    }

    listItem.classList.add('is-selected');
  });

  document.addEventListener('DOMContentLoaded', () => {
    let selectedItemVariants = document.querySelector('.is-single .product__form__holder')
    let bundleItem = document.querySelector('.is-bundle');
    if (!bundleItem) return;
    bundleItem.append(selectedItemVariants);
    bundleItem.append(sellingPlans);
    bundleItem.append(freeOrderText);
  })

  function changeImage(index){
    let allThumbs = document.querySelectorAll('.product__thumb');
    allThumbs.forEach(thumb => thumb.classList.remove('is-active'))
    var thumbElement = document.querySelector(`.product__thumb__link[data-thumb-index="${index}"]`);
    if (!thumbElement) return;
    thumbElement.parentElement.classList.add('is-active');
    let imgSrc = thumbElement.querySelector('img').getAttribute('src')
    let allMainPhotos = document.querySelectorAll('.product__slide');
    allMainPhotos.forEach(photo => {
      photo.classList.remove('is-selected')
      if(photo.dataset.thumb == imgSrc){
        photo.classList.add('is-selected')
      }
    })
  }
})()
